import React from 'react'
import {
  individualAccountSubscriptionCards,
  individualAccountHowItWorks,
} from '../data/IndividualAccountData'
import { TabBottom } from './Extra/TabBottom'
import { SubscriptionCardBig } from './SubscriptionCard/SubscriptionCardBig'

export const IndividualAccountTab = () => (
  <>
    <h2 className='text-[#3232B0] font-medium sm:font-bold text-base sm:text-[32px] pb-4'>
      Individual Profile: manage your profile and connect with clients
    </h2>

    <p className='text-[#6E7785] text-xs sm:text-base sm:font-bold tracking-wide'>
      Legal Utopia's Lawyer Portal also provides a comprehensive platform for
      individual solicitors and barristers, where they can manage/update their
      profiles, schedule appointments, and engage with clients. Whether you're a
      sole practitioner or part of a firm or chambers, the Lawyer Portal equips
      you with the tools to boost your online presence and streamline client
      interactions.
    </p>

    <hr className='my-10 sm:my-15' />

    <section className='flex flex-col'>
      <h3 className='text-sm sm:text-2xl font-medium sm:font-bold text-center sm:text-start pb-4'>
        Membership plans and pricing
      </h3>

      <p className='text-[#6E7785] text-xs sm:text-base text-center sm:text-start pb-10'>
        Each membership plan provides useful resources that make profile
        management, booking, and client engagement straightforward and
        efficient.
      </p>

      <div className='flex flex-col gap-12 sm:gap-10 pb-10'>
        {individualAccountSubscriptionCards.map((card, index) => (
          <SubscriptionCardBig key={card.title + index} card={card} />
        ))}
      </div>

      <p className='text-xs sm:text-base tracking-wide font-normal sm:font-medium text-[#6E7785] pb-25'>
        All prices exclude VAT. Our plans offer flexibility, allowing you to
        pick the model that suits your billing approach and feature
        requirements.
      </p>

      <TabBottom data={individualAccountHowItWorks} className='bg-[#020251]' />
    </section>
  </>
)
